import { render, staticRenderFns } from "./ModalConfirmDelete.vue?vue&type=template&id=6f8f2dd2"
import script from "./ModalConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports